<template>
    <vx-table-row>
        <vx-table-row-title>
            <vx-badge color="slate" size="xs" class="font-mono" data-test="brand-id">
                {{ props.modelValue.brand_id }}
            </vx-badge>
        </vx-table-row-title>

        <vx-table-row-item>
            <template v-slot:label> Source: </template>
            <span data-test="source">{{ sourceLabels[props.modelValue.source] }}</span>
        </vx-table-row-item>

        <vx-table-row-item data-test="display-name">
            <template v-slot:label> Name: </template>
            <span class="text-sm font-bold line-clamp-2" :title="props.modelValue.display_name ?? undefined">
                {{ props.modelValue.display_name || '—' }}
            </span>
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label> Verification: </template>
            <vx-popover hover :arrow="true" placement="top">
                <span :class="{ 'font-bold': props.modelValue.verified }" data-test="verification">
                    {{ verifiedLabel(props.modelValue.verified) }}
                </span>
                <template v-slot:content>
                    <kiosk-tcr-brand-vetting-card
                        :verified="props.modelValue.verified"
                        :vettingScore="props.modelValue.vetting_score"
                        :entityType="props.modelValue.entity_type"
                        :vettingClass="props.modelValue.vetting_class"
                        :vettingStatus="props.modelValue.vetting_status"
                    ></kiosk-tcr-brand-vetting-card>
                </template>
            </vx-popover>
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label> Trust Score: </template>
            <span data-test="trust-score">{{ props.modelValue.vetting_score ?? '—' }}</span>
        </vx-table-row-item>

        <vx-table-row-item data-test="campaigns-count">
            <template v-slot:label> Campaigns: </template>
            {{ props.modelValue.campaigns_count }}
        </vx-table-row-item>

        <vx-table-row-item data-test="synced-at">
            <template v-slot:label> Synced: </template>
            <vx-popover hover :arrow="true" placement="top" :key="syncedAtKey">
                {{ fromNow(props.modelValue.synced_at) }}
                <template v-slot:content>
                    {{ shortDateTime(props.modelValue.synced_at) }}
                </template>
            </vx-popover>
        </vx-table-row-item>
    </vx-table-row>
</template>

<script lang="ts" setup>
import { VxBadge, VxPopover, VxTableRow, VxTableRowItem, VxTableRowTitle } from '@voxie/frontend-components';
import { useInterval } from '@vueuse/core';
import KioskTcrBrandVettingCard from '~/components/kiosk/kiosk-ten-dlc/list/KioskTcrBrandVettingCard.vue';
import { sourceLabels, verifiedLabel } from '~/components/kiosk/kiosk-ten-dlc/tenDlcLabels';
import type { TcrBrand } from '~/services/adminTenDlcClient.types';
import { fromNow, shortDateTime } from '~/utils/date';

const props = defineProps<{
    modelValue: TcrBrand;
}>();

const syncedAtKey = useInterval(60000);
</script>
